@use '@/styles/tokens' as *;

/* Mirrors warranty-claim-detail-drawer.module.scss `.body`. */
.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.head {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.refRow {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.timeline {
  display: flex;
  flex-direction: column;
}

.timelineItem {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  padding-bottom: var(--space-6);

  &:last-child {
    padding-bottom: 0;
  }
}

.timelineText {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding-top: 2px;
}

.thread {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.comment {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
  background: $color-neutral-100;
  border-radius: 12px;
}

.composer {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding-top: var(--space-4);
  border-top: 1px solid $color-neutral-200;
}
